import { captureMessage } from '@sentry/react';
import type { LoginLocationState } from 'app/Public/Login/Login';
import type { LogoutLocationState } from 'app/Public/Logout';
import { browserHistory } from 'init/redux-store';

const STEP_UP_STORAGE_KEY = 'mfa-step-up';
const AUTH_PATHS: ReadonlyArray<string> = ['/login', '/logout'];

export const isStepUpInProgress = () => window.sessionStorage.getItem(STEP_UP_STORAGE_KEY) !== null;

export const clearStepUp = () => window.sessionStorage.removeItem(STEP_UP_STORAGE_KEY);

export const redirectToStepUp = () => {
  if (AUTH_PATHS.includes(browserHistory.location.pathname)) return;

  if (isStepUpInProgress()) {
    clearStepUp();
    captureMessage('MFA step-up failed: still mfa_required after an MFA login', {
      fingerprint: ['mfa-step-up-failed'],
    });
    browserHistory.push('/logout', { isMfaFailed: true } satisfies LogoutLocationState);
    return;
  }

  window.sessionStorage.setItem(STEP_UP_STORAGE_KEY, 'true');
  const { pathname, search } = browserHistory.location;
  browserHistory.push('/login', {
    returnTo: `${pathname}${search}`,
    isStepUp: true,
  } satisfies LoginLocationState);
};
